@let isTplBlock = template() === 'block';
@let isTplInline = template() === 'inline';
@let isTplClock = template() === 'clock';
@let isLabelOnTop = props?.content?.title?.position === 'top';
@let isLabelOnRight = props?.content?.title?.position === 'right';
<section
  class="w-full h-full flex justify-center {{ isLabelOnTop ? 'flex-col gap-16' : 'gap-8' }}"
  [class.flex-row-reverse]="isLabelOnRight"
  [style]="wrapperStyles()"
>
  @if (labelEnabled()) {
    <blaze-element-label
      [color]="props?.style?.general?.title?.color1"
      [extendInputPadding]="elementContext?.extendInputPadding"
      [fontFamily]="props?.style?.general?.fontFamily"
      [fontSize]="props?.style?.general?.fontSize"
      [fontStyle]="props?.style?.general?.fontStyle"
      [fontWeight]="props?.style?.general?.fontWeight"
      [iconSize]="props?.style?.general?.iconSize"
      [lineHeight]="props?.style?.general?.lineHeight"
      [horizontalAlign]="props?.content?.title?.align"
      [icon]="props?.content?.title?.icon"
      [iconColor]="props?.content?.title?.iconColor?.color1"
      [iconPosition]="props?.content?.title?.iconPosition"
      [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
      [position]="props?.content?.title?.position"
      [tooltip]="props?.content?.title?.tooltip"
      [width]="isLabelOnTop ? '100%' : props?.content?.title?.width"
    >
      {{ labelText() }}
    </blaze-element-label>
  }
  <div
    class="control tpl-{{ template() }} {{ isTplClock ? '' : templateGridClass() }}"
    [class.with-dividers]="isTplInline && showDividers()"
    [style]="controlStyles()"
  >
    @if (isTplClock) {
      <div class="relative w-full flex items-center justify-center">
        <div class="clock-track absolute inset-0">
          <svg #svg class="w-full h-full" overflow="visible" viewBox="0 0 100 100">
            <circle
              class="clock-gutter"
              [attr.cx]="50"
              [attr.cy]="50"
              [attr.r]="50"
              fill="none"
              vector-effect="non-scaling-stroke"
            />
            <circle
              class="clock-progress"
              [attr.cx]="50"
              [attr.cy]="50"
              [attr.r]="50"
              fill="none"
              vector-effect="non-scaling-stroke"
              stroke-linecap="round"
              [attr.stroke-dasharray]="clockValuesDash()"
              [attr.stroke-dashoffset]="clockValuesOffset()"
            />
          </svg>
        </div>
        <div class="w-full flex items-center justify-center gap-4">
          <span class="flex-1 text-right" [style]="stylesTimeLabel()">{{ displayMin() }}</span>
          <span class="flex flex-shrink items-center" [style]="stylesTimeValue()">:</span>
          <span class="flex-1 text-left" [style]="stylesTimeLabel()">{{ displaySec() }}</span>
        </div>
      </div>
    } @else {
      @if (showDay()) {
        @if (isTplBlock) {
          <div class="seg-day" [style]="stylesDay()">
            <span>{{ displayDay() }} DAY{{ displayDay() !== 1 ? 'S' : '' }}</span>
          </div>
        } @else {
          <div class="seg-time" [style]="stylesTime()">
            <span [style]="stylesTimeValue()">{{ displayDay() }}</span>
            <span [style]="stylesTimeLabel()">D</span>
          </div>
        }
      }
      @if (showHrs()) {
        <div class="seg-time" [style]="stylesTime()">
          <span [style]="stylesTimeValue()">{{ displayHrs() }}</span>
          <span [style]="stylesTimeLabel()">{{ isTplBlock ? 'hours' : 'H' }}</span>
        </div>
      }
      @if (isTplBlock && showHrs() && (showMin() || (!showMin() && showSec()))) {
        <span class="flex flex-shrink items-center" [style]="stylesTimeValue()">:</span>
      }
      @if (showMin()) {
        <div class="seg-time" [style]="stylesTime()">
          <span [style]="stylesTimeValue()">{{ displayMin() }}</span>
          <span [style]="stylesTimeLabel()">{{ isTplBlock ? 'mins' : 'M' }}</span>
        </div>
      }
      @if (isTplBlock && showMin() && showSec()) {
        <span class="flex flex-shrink items-center" [style]="stylesTimeValue()">:</span>
      }
      @if (showSec()) {
        <div class="seg-time" [style]="stylesTime()">
          <span [style]="stylesTimeValue()">{{ displaySec() }}</span>
          <span [style]="stylesTimeLabel()">{{ isTplBlock ? 'secs' : 'S' }}</span>
        </div>
      }
    }
  </div>
</section>
